const Registro = () => {
  return (
    <>
      <h1>Registro</h1>
    </>
  );
};

export default Registro;